import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LearnIcon from './components/LearnIcon';
import ExploreIcon from './components/ExploreIcon';
import ReflectIcon from './components/ReflectIcon';
import PlanIcon from './components/PlanIcon';
import learnPicture from './assets/Learn.png';
import explorePicture from './assets/Explore.png';
import planPicture from './assets/Plan.png';
import reflectPicture from './assets/Reflect.png';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import './styles/approach.scss';
import './styles/approach-animate.scss';

export default class Approach extends Component {

  contentRefs = {};

  getContentRef(key) {
    if (!this.contentRefs[key]) {
      this.contentRefs[key] = React.createRef();
    }
    return this.contentRefs[key];
  }

  constructor(props) {
    super(props);
    this.state = { slide: 0, shownApproach: {}, hover: null, buttonsActive: true };
  }

  findPicture(approachNumber) {
    switch (approachNumber) {
      case 0:
        return learnPicture;
      case 1:
        return explorePicture;
      case 2:
        return reflectPicture;
      case 3:
        return planPicture;
    }
  }

  enableButtons() {
    setTimeout(() => {
      this.setState({ buttonsActive: true });
    }, 300);
  }

  renderContent(shownApproach) {
    return (
      <CSSTransition key={shownApproach.title}
        nodeRef={this.getContentRef(shownApproach.title)}
        classNames="approach-animate"
        timeout={300}>
        <div ref={this.getContentRef(shownApproach.title)} className="approach-section__container__content">
          <img src={this.findPicture(shownApproach.approachNumber)}
            alt={`${shownApproach.title} image`}
            className="approach-section__container__content__img" />
          <h3 className="approach-section__container__content__title">{shownApproach.title}</h3>
          <p className="approach-section__container__content__text">
            {shownApproach.approachText}
          </p>
        </div>
      </CSSTransition>
    );
  }

  handleSlideChange(slide, approaches, init) {
    const setShownApproach = approaches.filter((approach) => {
      return slide === approach.approachNumber;
    });

    if (this.state.buttonsActive || init) {
      this.enableButtons();
      this.setState({ slide: slide, shownApproach: setShownApproach[0], buttonsActive: false });
    }
  }

  handleHover(slide) {
    this.setState({ hover: slide });
  }

  handleUnHover(slide) {
    this.setState({ hover: null });
  }

  init(props) {
    if (props.approaches) {
      this.setState({ slide: 0, shownApproach: {} });
      this.handleSlideChange(0, props.approaches, true);
    }
  }

  componentDidMount() {
    this.init(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.init(newProps);
  }

  render() {
    const { slide, shownApproach, hover } = this.state;
    const { approaches } = this.props;
    return (
      <div className="approach-section">
        <div className="approach-section__line" />
        <div className="approach-section__slide">
          { approaches &&
            approaches.map((approach, i) =>
              <div key={i} className="approach-section__slide__area">
                <button
                  className={'approach-section__slide__area__btn ' + ((slide === i || hover === i) ? 'active' : 'inactive')}
                  onClick={() => this.handleSlideChange(i, approaches)}
                  onMouseEnter={() => this.handleHover(i)}
                  onMouseLeave={() => this.handleUnHover(i)}
                  >
                  { i === 0 &&
                    <LearnIcon active={shownApproach.approachNumber === 0 || hover === 0} />
                  }
                  { i === 1 &&
                    <ExploreIcon active={shownApproach.approachNumber === 1 || hover === 1} />
                  }
                  { i === 2 &&
                    <ReflectIcon active={shownApproach.approachNumber === 2 || hover === 2} />
                  }
                  { i === 3 &&
                    <PlanIcon active={shownApproach.approachNumber === 3 || hover === 3} />
                  }
                </button>
                <div
                  className={'approach-section__slide__area__btn approach-section__slide__area__btn--small ' + ((slide === i || hover === i) ? 'active' : 'inactive')}
                  onClick={() => this.handleSlideChange(i, approaches)}
                  onMouseEnter={() => this.handleHover(i)}
                  onMouseLeave={() => this.handleUnHover(i)}
                  />
                <h3 className={'approach-section__slide__area__text ' + (slide !== i ? 'inactive-text' : '')}>{approaches[i].title}</h3>
              </div>
            )
          }
        </div>
        <div className="approach-section__container">
          <TransitionGroup>
            {this.renderContent(shownApproach)}
          </TransitionGroup>
        </div>
      </div>
    );
  }
}

Approach.propTypes = {
  approaches: PropTypes.array
};
